import { useState, useEffect } from 'react';
import API from '../services/api';

function Statistics() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    setLoading(true);
    try {
      const response = await API.get('/organization/stats');
      setStats(response.data.data);
    } catch (error) {
      console.error('Error loading stats:', error);
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner">⏳</div>
          <p className="loading-text">Loading stats...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="stats-page">
      <div className="stats-page-wrapper">

        {/* Header */}
        <div className="page-header">
          <h1 className="page-title">📊 Statistics</h1>
          <p className="page-subtitle">Platform usage and analytics</p>
        </div>

        {stats && (
          <>
            {/* Stats Cards */}
            <div className="dash-stats-grid" style={{ marginBottom: '24px' }}>
              <div className="dash-stat-card dash-stat-indigo">
                <div className="dash-stat-label">Total Flows</div>
                <div className="dash-stat-value">{stats.totalFlows}</div>
                <div className="dash-stat-sub">Active automations</div>
              </div>
              <div className="dash-stat-card dash-stat-violet">
                <div className="dash-stat-label">Total Contacts</div>
                <div className="dash-stat-value">{stats.totalContacts}</div>
                <div className="dash-stat-sub">Registered contacts</div>
              </div>
              <div className="dash-stat-card dash-stat-blue">
                <div className="dash-stat-label">Total Messages</div>
                <div className="dash-stat-value">{stats.totalMessages}</div>
                <div className="dash-stat-sub">All time sent & received</div>
              </div>
              <div className="dash-stat-card dash-stat-sky">
                <div className="dash-stat-label">Today's Messages</div>
                <div className="dash-stat-value">{stats.todayMessages}</div>
                <div className="dash-stat-sub">Messages today</div>
              </div>
            </div>

            {/* Summary Card */}
            <div className="dash-card">
              <h3 className="dash-card-title">📈 Platform Summary</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                <div className="stats-summary-item">
                  <div className="stats-summary-icon">🔄</div>
                  <div>
                    <div className="stats-summary-label">Avg Messages / Contact</div>
                    <div className="stats-summary-value">
                      {stats.totalContacts > 0
                        ? (stats.totalMessages / stats.totalContacts).toFixed(1)
                        : '0'}
                    </div>
                  </div>
                </div>
                <div className="stats-summary-item">
                  <div className="stats-summary-icon">📅</div>
                  <div>
                    <div className="stats-summary-label">Today vs Total</div>
                    <div className="stats-summary-value">
                      {stats.totalMessages > 0
                        ? ((stats.todayMessages / stats.totalMessages) * 100).toFixed(1)
                        : '0'}%
                    </div>
                  </div>
                </div>
                <div className="stats-summary-item">
                  <div className="stats-summary-icon">⚙️</div>
                  <div>
                    <div className="stats-summary-label">Active Flows</div>
                    <div className="stats-summary-value">{stats.totalFlows}</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {!stats && (
          <div className="dash-card" style={{ textAlign: 'center', padding: '60px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📊</div>
            <p style={{ color: '#94a3b8', fontSize: '16px' }}>No statistics available yet.</p>
          </div>
        )}

      </div>
    </div>
  );
}

export default Statistics;